module.exports = __webpack_public_path__ + "static/blGif-53703d74d28062295a616ab8ea7f1207.gif";